/* import __COLOCATED_TEMPLATE__ from './limit-reached-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    onDismiss: () => void;
  };
}

const LimitReachedBanner = templateOnlyComponent<Signature>();
export default LimitReachedBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinUsageGlobalBanners::LimitReachedBanner': typeof LimitReachedBanner;
    'fin-usage-global-banners/limit-reached-banner': typeof LimitReachedBanner;
  }
}
